<template>
    <div>
        <van-popup v-model="show" :close-on-click-overlay="false">
            <div class="dialog-content">
                <div class="icon-wrapper">
                    <img
                        src="./file-icon.png"
                        width="100%"
                        height="100%"
                        alt=""
                    />
                </div>
                <div class="item-wrapper">
                    <label class="input-wrapper" :class="{ checked: checked }">
                        <input
                            ref="input"
                            type="checkbox"
                            v-model="checked"
                            hidden
                            class="input"
                        />
                    </label>
                    <p>
                        请查阅并同意
                        <a
                            href="javascript:;"
                            class="link"
                            @click="
                                showDialog('#/user-authorization-doc', $event)
                            "
                            >《服务协议》</a
                        >和<a
                            href="javascript:;"
                            class="link"
                            @click="showDialog('#/private-policy-doc', $event)"
                            >《隐私政策》</a
                        >
                    </p>
                </div>
                <a
                    href="javascript:;"
                    class="btn"
                    :class="{ checked: checked }"
                    @click="submit"
                    >同意</a
                >
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false,
            checked: false,
        };
    },
    mounted() {
        if (window.sessionStorage.getItem("doc-preview-checked")) {
            this.checked = true;
            this.$nextTick(() => {
                window.sessionStorage.removeItem("doc-preview-checked");
            });
        }
    },
    methods: {
        submit() {
            if (!this.checked) {
                return;
            }
            this.$http({
                loading: true,
                url: "/bdzb-core-service/guarantee/authorizationLog",
                data: { authorizationType: 3 },
                method: "POST",
            }).then(() => {
                this.show = false;
            });
        },
        showDialog(path) {
            if (this.checked) {
                window.sessionStorage.setItem("doc-preview-checked", "checked");
            } else {
                window.sessionStorage.removeItem("doc-preview-checked");
            }
            let baseUrl = process.env.VUE_APP_DOC_URI;
            location.href = baseUrl + location.search + path;
        },
    },
};
</script>
<style scoped>
.van-popup {
    background-color: transparent;
}
.dialog-content {
    width: 2.36rem;
    height: 2.64rem;
    border-radius: 0.11rem;
    background-color: #fff;
    overflow: hidden;
}
.dialog-content.confirm {
    width: 2.8rem;
    height: 1.56rem;
}

.icon-wrapper {
    height: 0.99rem;
}
.dialog-content .title {
    padding-top: 0.2rem;
    font-size: 0.15rem;
    text-align: center;
    color: #0f2742;
}
.dialog-content .text {
    line-height: 0.6rem;
    font-size: 0.14rem;
    color: #0f2742;
    text-align: center;
}
.dialog-content .btn {
    display: block;
    width: 1.68rem;
    height: 0.33rem;
    line-height: 0.33rem;
    text-align: center;
    margin: 0.3rem auto;
    font-size: 0.14rem;
    font-weight: bold;
    color: #fff;
    background-color: #ccdffd;
    border-radius: 0.16rem;
}
.dialog-content .btn.checked {
    background-color: #3b97ff;
}
.item-wrapper {
    position: relative;
    margin: 0.15rem;
    padding-left: 0.2rem;
    font-size: 0.13rem;
    text-align: justify;
    line-height: 1.6;
}
.input-wrapper {
    position: absolute;
    top: 0.04rem;
    left: 0;
    display: block;
    width: 0.14rem;
    height: 0.14rem;
    background-image: url(./radio.png);
    background-size: 100%;
}
.input-wrapper.checked {
    background-image: url(./radio-checked.png);
}
.item-wrapper .link {
    color: #3a72fc;
}
.item-wrapper .link.active {
    color: #843afc;
}
</style>
